import { useState } from 'react';
import { useArchivo, useConsulta, useSubida } from '@plataforma/web/api';
import { fechaCorta } from '../formato';
import type { Documento } from '../paginas/tipos';

function Miniatura({ d }: { d: Documento }) {
  const url = useArchivo(`/inventory/documentos/${d.id}/contenido`);
  return (
    <a href={url ?? '#'} target="_blank" rel="noreferrer" title={d.nombreArchivo}>
      {url ? (
        <img
          src={url}
          alt={d.nombreArchivo}
          style={{
            width: 140,
            height: 100,
            objectFit: 'cover',
            borderRadius: 8,
            border: '1px solid var(--borde)',
          }}
        />
      ) : (
        <div
          style={{ width: 140, height: 100, borderRadius: 8, background: 'var(--borde-suave)' }}
        />
      )}
    </a>
  );
}

/** Fotos y documentos del vehículo (Media & Documents de Inventario). */
export function DocumentosVehiculo({ vehiculoId }: { vehiculoId: string }) {
  const { datos, recargar } = useConsulta<Documento[]>(
    `/inventory/vehiculos/${vehiculoId}/documentos`,
  );
  const subir = useSubida();
  const [error, setError] = useState<string | null>(null);
  const fotos = (datos ?? []).filter(
    (d) => d.tipo === 'foto' && d.tipoContenido.startsWith('image/'),
  );
  const otros = (datos ?? []).filter((d) => !fotos.includes(d));
  const agregar = async (archivos: FileList | null, tipo: string) => {
    setError(null);
    for (const a of Array.from(archivos ?? []))
      await subir(
        `/inventory/vehiculos/${vehiculoId}/documentos?tipo=${tipo}&nombre=${encodeURIComponent(a.name)}`,
        a,
      ).catch((e: Error) => setError(`${a.name}: ${e.message}`));
    recargar();
  };
  return (
    <section className="seccion">
      <header>
        <h2>Fotos y documentos</h2>
        <div style={{ flex: 1 }} />
        <label className="boton">
          Agregar fotos
          <input
            type="file"
            multiple
            accept="image/jpeg,image/png,image/webp,image/heic"
            hidden
            onChange={(e) => void agregar(e.target.files, 'foto')}
          />
        </label>
        <label className="boton">
          Agregar documento (PDF)
          <input
            type="file"
            accept="application/pdf"
            hidden
            onChange={(e) => void agregar(e.target.files, 'otro')}
          />
        </label>
      </header>
      {error && (
        <p className="error" style={{ margin: 16 }}>
          {error}
        </p>
      )}
      {datos && !datos.length ? (
        <p className="vacio">Sin fotos ni documentos.</p>
      ) : (
        <div className="cuerpo" style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {fotos.map((d) => (
            <Miniatura key={d.id} d={d} />
          ))}
          {otros.map((d) => (
            <span key={d.id} className="etiqueta" title={fechaCorta(d.creadoEn)}>
              {d.tipo} · {d.nombreArchivo}
            </span>
          ))}
        </div>
      )}
    </section>
  );
}
